import $ from 'jquery';
import _ from 'lodash';

export default class Store {
    constructor(url, store) {
        if (!_.isObject(store) && console && console.warning) console.warning("store: session store is not loaded");
        this._store = store || {};
        this._url = url;
    }

    read(...args) {
        let result = _.foldl(args, function(o, v) {
            return _.isPlainObject(o) ? o[v] : o;
        }, this._store);

        return _.cloneDeep(result);
    }

    write(value) {
        let dfd = new $.Deferred();

        if (!_.isObject(value)) throw new Error("store: value to store must be an object");

        $.ajax({
            url: this._url,
            type: 'PUT',
            contentType: 'application/json; charset: utf-8',
            data: JSON.stringify(value),
            success() {
                dfd.resolve();
            },
            error() {
                if (_.isObject(console)) {
                    console[console.warn ? 'warn' : 'log']("unable to save session store");
                }
                dfd.reject();
            }
        });

        this._store = _.tidy(_.merge(this._store, value));

        return dfd.promise();
    }
}



/** WEBPACK FOOTER **
 ** ./js/app/common/store.js
 **/